"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@mui/styles");
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _colors = require("../attrs/colors");
var _styles2 = require("./styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function TooltipInfo(_ref) {
  var titleTooltip = _ref.titleTooltip;
  var isMobile = (0, _useMediaQuery["default"])('(max-width:425px)');
  var tooltipRef = (0, _react.useRef)(null);
  var returnPlacement = function returnPlacement() {
    if (isMobile) {
      return 'bottom';
    }
    return 'right';
  };
  var valueOffset = isMobile ? '-30px, 0' : '0, 0';
  var useTooltipStyles = (0, _styles.makeStyles)(function () {
    return {
      arrow: {
        color: _colors.PRIMARY_TEXT_COLOR
      },
      tooltip: {
        backgroundColor: _colors.PRIMARY_TEXT_COLOR
      }
    };
  });
  var CustomTooltip = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    var classes = useTooltipStyles();
    // eslint-disable-next-line react/prop-types
    var disableHoverListener = props.disableHoverListener;
    return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], _extends({
      arrow: true,
      disableHoverListener: disableHoverListener,
      leaveTouchDelay: 3000,
      classes: classes,
      ref: ref
    }, props), props.children);
  });
  return /*#__PURE__*/_react["default"].createElement(CustomTooltip, {
    ref: tooltipRef,
    enterTouchDelay: 0,
    placement: returnPlacement(),
    title: titleTooltip,
    disableHoverListener: false,
    PopperProps: {
      popperOptions: {
        modifiers: {
          offset: {
            enabled: true,
            offset: valueOffset
          }
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_styles2.InfoIcon, {
    iconName: "info"
  })));
}
TooltipInfo.propTypes = {
  titleTooltip: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = TooltipInfo;